import React, { useRef, useState } from 'react';
import { Handle, Position } from '@xyflow/react';
import PropTypes from 'prop-types';
import {
  Box,
  Grow,
  IconButton,
  Paper,
  Typography,
  useTheme,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import fieldMapping from '../images/Field-mapping.png';
import NoMapping from '../images/No-transformation.svg';
import Decision from '../images/decision_icon.svg';
import Jira from '../images/JIRA.svg';
import EtlMappingDialog from '../Component/EtlMappingDialog';
import { useThemeContext } from '../../Context/ThemeContext';
// Commented: not used - mapping initialization only via bottom panel
// import { useNavigate, useParams } from 'react-router-dom';
// import { useSelector } from 'react-redux';

// const findSourceNode = (nodes) =>
//   nodes.find((n) => n.type === 'sourceNode' || n.type === 'source');
// const findDestNode = (nodes) =>
//   nodes.find((n) => n.type === 'destinationNode' || n.type === 'destination');

const IntegrationNode = ({ id, data, deleteNode, updatedConfig /* , onEntitySelectionComplete // Commented: not used - mapping initialization only via bottom panel */ }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isHandleHover, setIsHandleHover] = useState(false);
  const hoverTimeout = useRef(null);
  const clickTimeoutRef = useRef(null);

  // Commented: not used - mapping initialization only via bottom panel
  // const { workflowName: workflowId } = useParams();
  // const navigate = useNavigate();

  // old code of single to single node

  // const sourceNode = findSourceNode(updatedConfig?.nodes || []);
  // const destNode = findDestNode(updatedConfig?.nodes || []);

  // if (!sourceNode || !destNode) {
  //   console.warn('sourceNode or destNode not found for this IntegrationNode');
  // }

  // const sourceKey = `${sourceNode?.id}-${
  //   sourceNode?.config?.connection?.conn_id || ''
  // }-${sourceNode?.config?.module || ''}`;
  // const destKey = `${destNode?.id}-${
  //   destNode?.config?.connection?.conn_id || ''
  // }-${destNode?.config?.module || ''}`;

  // const confirmedSourceEntities = useSelector(
  //   (state) =>
  //     state.entities.confirmedSourceEntitiesByWorkflow?.[workflowId]?.[
  //       sourceKey
  //     ] || []
  // );
  // const confirmedDestinationEntities = useSelector(
  //   (state) =>
  //     state.entities.confirmedDestinationEntitiesByWorkflow?.[workflowId]?.[
  //       destKey
  //     ] || []
  // );

  // const sourceError = useSelector(
  //   (s) =>
  //     s.entities?.sourceErrorByWorkflow?.[workflowId]?.[sourceKey] || null
  // );
  // const destinationError = useSelector(
  //   (s) =>
  //     s.entities?.destinationErrorByWorkflow?.[workflowId]?.[destKey] || null
  // );

  // const isConnected =
  //   sourceNode &&
  //   destNode &&
  //   updatedConfig?.edges?.some(
  //     (edge) => edge.source === sourceNode?.id && edge.target === id
  //   ) &&
  //   updatedConfig?.edges?.some(
  //     (edge) => edge.source === id && edge.target === destNode?.id
  //   );

  // const canOpenMapping =
  //   confirmedSourceEntities.length > 0 &&
  //   confirmedDestinationEntities.length > 0 &&
  //   isConnected &&
  //   !sourceError &&
  //   !destinationError;

  /////////////////////////////////////////////////////////

  const sourceNodes = (updatedConfig?.nodes || []).filter(
    (n) => n.type === 'sourceNode' || n.type === 'source'
  );
  const destNodes = (updatedConfig?.nodes || []).filter(
    (n) => n.type === 'destinationNode' || n.type === 'destination'
  );

  // const isOneToMany = sourceNodes.length === 1 && destNodes.length > 1; // Commented: not used - mapping initialization only via bottom panel


  if (sourceNodes.length === 0 || destNodes.length === 0) {
    console.warn('No source/destination nodes for this IntegrationNode');
  }

  // Commented: not used - mapping initialization only via bottom panel
  // const sourceKeys = sourceNodes.map(
  //   (sn) =>
  //     `${sn.id}-${sn.config?.connection?.conn_id || ''}-${
  //       sn.config?.module || ''
  //     }`
  // );
  // const destKeys = destNodes.map(
  //   (dn) =>
  //     `${dn.id}-${dn.config?.connection?.conn_id || ''}-${
  //       dn.config?.module || ''
  //     }`
  // );

  // Commented: not used - mapping initialization only via bottom panel
  // const allSourcesConfirmed = useSelector((s) =>
  //   sourceKeys.every(
  //     (k) =>
  //       (
  //         s.entities.confirmedSourceEntitiesByWorkflow?.[workflowId]?.[k] ||
  //         []
  //       ).length > 0
  //   )
  // );
  // const allDestsConfirmed = useSelector((s) =>
  //   destKeys.every(
  //     (k) =>
  //       (
  //         s.entities.confirmedDestinationEntitiesByWorkflow?.[workflowId]?.[
  //           k
  //         ] || []
  //       ).length > 0
  //   )
  // );

  // const sourceError = useSelector((s) => {
  //   const byWf = s.entities.sourceErrorByWorkflow?.[workflowId] || {};
  //   return sourceKeys.map((k) => byWf[k]).find(Boolean) || null;
  // });
  // const destinationError = useSelector((s) => {
  //   const byWf = s.entities.destinationErrorByWorkflow?.[workflowId] || {};
  //   return destKeys.map((k) => byWf[k]).find(Boolean) || null;
  // });

  // Get selected entities for building finalConfigPayload
  // Commented: not used - mapping initialization only via bottom panel
  // const selectedSourceEntitiesByWorkflow = useSelector(
  //   (s) => s.entities?.selectedSourceEntitiesByWorkflow?.[workflowId] || {}
  // );
  // const selectedDestinationEntitiesByWorkflow = useSelector(
  //   (s) => s.entities?.selectedDestinationEntitiesByWorkflow?.[workflowId] || {}
  // );

  const edges = updatedConfig?.edges || [];
  const hasIncomingFromAllSources = sourceNodes.every((sn) =>
    edges.some((e) => e.source === sn.id && e.target === id)
  );
  const hasOutgoingToAllDests = destNodes.every((dn) =>
    edges.some((e) => e.source === id && e.target === dn.id)
  );
  const isConnected = hasIncomingFromAllSources && hasOutgoingToAllDests;

  // Commented: not used - mapping initialization only via bottom panel
  // const canOpenMapping =
  //   allSourcesConfirmed &&
  //   allDestsConfirmed &&
  //   isConnected &&
  //   !sourceError &&
  //   !destinationError;

  const handleNodeClick = () => {
    clickTimeoutRef.current = setTimeout(() => {
      // Don't auto-trigger mapping initialization on click
      // Mapping should only be initialized when user explicitly clicks "Proceed to Mapping" in bottom panel
      // This prevents unnecessary API calls when just clicking on the function node
      // The node click in ETLWorkflow.jsx will handle showing the mapping panel if needed
    }, 0);
  };

  console.log('data::: data', data);

  const [openDialog, setOpenDialog] = useState(false);
  const theme = useTheme();
  const { darkMode } = useThemeContext();

  const handleMouseEnter = () => {
    hoverTimeout.current = setTimeout(() => setIsHovered(true), 400);
  };

  const handleMouseLeave = () => {
    clearTimeout(hoverTimeout.current);
    setIsHovered(false);
    setIsHandleHover(false);
  };

  console.log('isHovered:', isHovered);
  console.log('isHandleHover:', isHandleHover);

  // Split label into main and type
  const [mainLabel, typeLabel] = data.label.includes('(')
    ? data.label.split(' (')
    : [data.label, ''];

  const displayType = typeLabel.replace(')', '').trim();

  let icon = fieldMapping;

  if (mainLabel.toLowerCase().includes('jira')) {
    icon = Jira;
  } else if (mainLabel.toLowerCase().includes('no transformation')) {
    icon = NoMapping;
  } else if (mainLabel.toLowerCase().includes('decision')) {
    icon = Decision;
  }

  const isJiraNode = mainLabel.toLowerCase().includes('jira');

  const canOpenEntityDialog = isConnected;

  const handleDoubleClick = () => {
    clearTimeout(clickTimeoutRef.current);
    if (!canOpenEntityDialog) return;        
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const ICON_SIZE = isJiraNode ? 40 : 32;
  const NODE_SIZE = isJiraNode ? 60 : 50;

  const showOverlay = isHovered && !isHandleHover;

  return (
    <>
      <Box
        sx={{
          width: NODE_SIZE,
          height: NODE_SIZE,
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '4px',
          bgcolor: isJiraNode ? '#fff' : '#5E9CFB', // base blue
          border: `1.5px solid ${isJiraNode ? '#3a8eff' : '#549bde'}`,
          boxShadow: isHovered
            ? '0 8px 20px rgba(84, 155, 222, 0.55)'
            : '0 4px 14px rgba(84, 155, 222, 0.45)',
          zIndex: isHovered ? 100 : 1,
          transition: 'box-shadow 0.25s ease, transform 0.25s ease',
          cursor: 'pointer',
          '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0 8px 16px rgba(0, 0, 0, 0.3)',
          },
        }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onDoubleClick={handleDoubleClick}
        onClick={handleNodeClick}
      >
        <Box
          sx={{
            width: ICON_SIZE,
            height: ICON_SIZE,
            borderRadius: '8px',
            bgcolor: '#5E9CFB',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img
            src={icon}
            alt={mainLabel}
            width={30}
            height={30}
            style={{ filter: 'brightness(0) invert(1)' }}
          />
        </Box>

        <Grow
          in={showOverlay}
          timeout={{ enter: 300, exit: 250 }}
          style={{
            transitionDelay: showOverlay ? '100ms' : '0ms',
          }}
        >
          <Paper
            elevation={4}
            sx={{
              position: 'absolute',
              top: -8,
              left: -12,
              minWidth: 190,
              minHeight: 50,
              px: 2,
              py: 1,
              display: 'flex',
              alignItems: 'center',
              borderRadius: 1,
              bgcolor: darkMode ? theme.palette.background.paper : '#fff',
              border: `1.5px solid ${darkMode ? '#3a8eff' : '#549bde'}`,
              zIndex: 200,
              transition: 'opacity 0.15s',
              pointerEvents: 'auto',
              boxShadow: '0 6px 12px rgba(0, 0, 0, 0.25)',
              '&:hover': {
                boxShadow: '0 8px 16px rgba(0, 0, 0, 0.3)',
              },
            }}
          >
            <Box
              sx={{
                width: 34,
                height: 34,
                borderRadius: 1,
                bgcolor: darkMode ? '#20223c' : '#f5f6fa',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mr: 2,
              }}
            >
              <img src={icon} alt={mainLabel} width={34} height={34} />
            </Box>
            <Box sx={{ ml: 1 }}>
              <Typography
                sx={{
                  color: darkMode ? '#b0b0b0' : '#757575',
                  fontSize: '0.75rem',
                  marginBottom: '0.25rem',
                }}
              >
                {displayType || 'Mapping'}
              </Typography>
              <Typography
                sx={{
                  color: darkMode ? '#fff' : '#212121',
                  fontSize: '0.875rem',
                  fontWeight: 600,
                }}
              >
                {mainLabel || 'Field-Mapping'}
              </Typography>
            </Box>
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                deleteNode(id, data.label);
              }}
              size="small"
              sx={{
                position: 'absolute',
                top: 6,
                right: 6,
                background: darkMode ? '#353535' : '#fff',
                color: darkMode
                  ? theme.palette.error.main
                  : theme.palette.error.main,
                width: '1.25rem',
                height: '1.25rem',
                borderRadius: '50%',
                boxShadow: 1,
                zIndex: 2,
                '&:hover': {
                  background: darkMode
                    ? theme.palette.error.dark
                    : theme.palette.error.dark,
                  color: '#fff',
                },
              }}
            >
              <Close sx={{ fontSize: '0.75rem' }} />
            </IconButton>
          </Paper>
        </Grow>

        {(!isHovered || isHandleHover) && (
          <>
            {isJiraNode ? (
              // ✅ Only 1 handle for Jira
              <>
                <Handle
                  type="target"
                  position={Position.Right}
                  onMouseEnter={() => setIsHandleHover(true)}
                  onMouseLeave={() => setIsHandleHover(false)}
                  style={{
                    zIndex: 300,
                    background: darkMode ? '#3a8eff' : '#549bde',
                  }}
                />
                <Handle
                  type="source"
                  position={Position.Left}
                  onMouseEnter={() => setIsHandleHover(true)}
                  onMouseLeave={() => setIsHandleHover(false)}
                  style={{
                    zIndex: 300,
                    background: darkMode ? '#3a8eff' : '#549bde',
                  }}
                />
              </>
            ) : (
              // ✅ 2 handles for all other nodes
              <>
                <Handle
                  type="target"
                  position={Position.Left}
                  onMouseEnter={() => setIsHandleHover(true)}
                  onMouseLeave={() => setIsHandleHover(false)}
                  style={{
                    zIndex: 300,
                    background: darkMode ? '#3a8eff' : '#549bde',
                  }}
                />
                <Handle
                  type="source"
                  position={Position.Right}
                  onMouseEnter={() => setIsHandleHover(true)}
                  onMouseLeave={() => setIsHandleHover(false)}
                  style={{
                    zIndex: 300,
                    background: darkMode ? '#3a8eff' : '#549bde',
                  }}
                />
              </>
            )}
          </>
        )}

        {/* {(!isHovered || isHandleHover) && (
          <>
            <Handle
              type="source"
              position={Position.Bottom}
              onMouseEnter={() => setIsHandleHover(true)}
              onMouseLeave={() => setIsHandleHover(false)}
              style={{
                zIndex: 300,
                background: darkMode ? '#3a8eff' : '#549bde',
              }}
            />
            <Handle
              type="source"
              position={Position.Right}
              onMouseEnter={() => setIsHandleHover(true)}
              onMouseLeave={() => setIsHandleHover(false)}
              style={{
                zIndex: 300,
                background: darkMode ? '#3a8eff' : '#549bde',
              }}
            />
          </>
        )} */}
      </Box>

      <EtlMappingDialog
        open={openDialog}
        onClose={handleCloseDialog}
        nodeId={id}
      />
    </>
  );
};

IntegrationNode.propTypes = {
  id: PropTypes.string.isRequired,
  data: PropTypes.shape({
    label: PropTypes.string,
  }).isRequired,
  deleteNode: PropTypes.func.isRequired,
  updatedConfig: PropTypes.object,
  // onEntitySelectionComplete: PropTypes.func, // Commented: not used - mapping initialization only via bottom panel
};

export default IntegrationNode;
